import { getRootVue } from '../../common/baseMain'
import { getRouter } from '../../common/baseRouter'
import { getStore } from '../../common/baseStore'
// import mainpage from './store'

import Question from './../question/List.vue'
import PaperPreview from './components/Preview.vue'
import DownloadFinish from './DownloadFinish.vue'
import Home from './Home.vue'
import PaperDetail from './PaperDetail.vue'
import Pdf from './pdf.vue'
import SourcePreview from './SourcePreview.vue'
// get router config
const router = getRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Question
    },
    {
      path: '/index',
      name: 'index',
      component: Question
    },
    {
      path: '/paper',
      name: 'paper',
      component: Home
    },
    {
      path: '/detail',
      name: 'detail',
      component: PaperDetail
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: Pdf
    },
    {
      path: '/finish',
      name: 'finish',
      component: DownloadFinish
    },
    {
      path: '/paperpreview',
      name: 'paperpreview',
      component: PaperPreview
    },
    {
      path: '/sourcepreview',
      name: 'sourcepreview',
      component: SourcePreview,
      meta: {
        modules: '素材课件讲义'
      }
    }
  ]
})
// let obj = getStore({ mainpage })
// get vue config
getRootVue({
  router
})

// export default obj
